var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "tabs",
      class: { vertical: _vm.vertical, flexy: _vm.flexy, wrap: _vm.wrap },
    },
    _vm._l(_vm.tabsModel, function (tab, index) {
      return _c(
        "div",
        {
          class: {
            active: index === _vm.modelValue.index,
            tab: true,
            disabled: tab.disabled,
            "text-primary": index !== _vm.modelValue.index,
            "text-body": index === _vm.modelValue.index,
            ...(function () {
              if (typeof tab.class === "string") return { [tab.class]: true }
              else return tab.class
            })(),
          },
          style: tab.style,
          on: {
            mouseup: function ($event) {
              if ("button" in $event && $event.button !== 1) return null
              return _vm.$emit("middlemouse", { tab, index })
            },
          },
        },
        [
          _vm._t(
            "default",
            function () {
              return [
                _vm._t("before", null, { tab: tab, i: index }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    class: {
                      "tab-content": true,
                      disabled: tab.disabled,
                    },
                    attrs: {
                      type: "button",
                      title: tab.title || "",
                      disabled: tab.disabled,
                    },
                    on: {
                      click: function ($event) {
                        _vm.modelValue = { tab, index }
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t" + _vm._s(tab.label ?? tab.value) + "\n\t\t\t"
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm._t("after", null, { tab: tab, i: index }),
              ]
            },
            { tab: tab, i: index }
          ),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }